import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PeopleListComponent } from './people-list/people-list.component';
import { PersonDetailsComponent } from './person-details/person-details.component';
import { VehicleListComponent } from './vehicle-list/vehicle-list.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';

// Route config let's you map routes to components
const routes: Routes = [
  {
    path: 'vehicles',
    component: VehicleListComponent,
  },
  // map '/persons/:id' to person details component
  {
    path: 'vehicles/:id',
    component: VehicleDetailsComponent,
  },
  // // map '/persons' to the people list component
  // {
  //   path: 'persons',
  //   component: PeopleListComponent,
  // },
  // // map '/persons/:id' to person details component
  // {
  //   path: 'persons/:id', 
  //   component: PersonDetailsComponent, 
  // },
  // map '/' to '/persons' as our default route
  {
    path: '',
    redirectTo: '/vehicles',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts